var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastForward = function SvgFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A94",
    d: "M1 12.328c-.531 0-1-.406-1-1.195V1.578C0 .79.469.383 1 .383c.281 0 .531.11.805.265l8.03 4.72c.337.202.532.429.61.702V1.578c0-.789.47-1.195 1.008-1.195.281 0 .531.11.797.265l8.031 4.72c.336.202.54.429.617.702v-5c0-.625.305-.93.922-.93h1.735c.617 0 .922.282.922.93v10.586c0 .625-.305.922-.922.922H21.82c-.617 0-.922-.297-.922-.922V6.641c-.078.273-.28.5-.617.703l-8.031 4.719c-.266.164-.516.265-.797.265-.539 0-1.008-.406-1.008-1.195V6.64c-.078.273-.28.5-.61.703l-8.03 4.719c-.266.164-.524.265-.805.265"
  })));
};
export default SvgFastForward;